import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { CSVLink } from 'react-csv';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

interface SubOrderTableProps {
  subOrder: { name: string, lineItems: any[] };
}

const SubOrderTable: FC<SubOrderTableProps> = (props) => {
  const classes = useStyles();
  let csvData = props?.subOrder?.lineItems.map((li) => (
    [li.title, li.quantity, li.originalUnitPriceSet.shopMoney.amount]
  ));
  csvData = [['Name', 'Quantity', 'Price'], ...csvData];
  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={4}>
              {props?.subOrder?.name}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="left">Name</TableCell>
            <TableCell align="center">Quantity</TableCell>
            <TableCell align="center">Price</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props?.subOrder?.lineItems.map((li) => (
            <TableRow key={li.title}>
              <TableCell component="th" align="left" scope="row">
                {li.title}
              </TableCell>
              <TableCell align="center">{li.quantity}</TableCell>
              <TableCell align="center">
                $
                {li.originalUnitPriceSet.shopMoney.amount}
              </TableCell>
            </TableRow>
          ))}
          <TableRow>
            <TableCell component="th" colSpan={1} align="left" scope="row">
              <CSVLink data={csvData}>Download me</CSVLink>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SubOrderTable;
